import { z } from 'zod';
import { RedocSchemaObject, extendApi } from '../../openapi';
import { i18nAttributes, uuid } from '../../utils';

export const publicRule = extendApi(
  z.object({
    id: uuid,
    name: extendApi(z.string(), {
      description: 'Name displayed in the Manager',
      example: 'Earn 10 coins for a visit',
    }),
    i18nAttributes: i18nAttributes(
      z.object({
        description: z.string(),
      }),
    ),
  }),
  {
    description: 'Defines how a member can earn or burn points',
    tags: ['rule-model', 'rule', 'model'],
  } as RedocSchemaObject,
);

export const publicRuleRef = extendApi(publicRule, {
  $ref: '#/components/schemas/Rule',
} as RedocSchemaObject);

export type PublicRule = z.infer<typeof publicRule>;
